import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = {
    dismissAfter: { type: Number, default: 5000 }
  }

  connect() {
    // Animate in: drop down and fade in
    requestAnimationFrame(() => {
      this.element.classList.remove("opacity-0", "-translate-y-4")
      this.element.classList.add("opacity-100", "translate-y-0")
    })

    if (this.dismissAfterValue > 0) {
      this.timeout = setTimeout(() => {
        this.dismiss()
      }, this.dismissAfterValue)
    }
  }

  disconnect() {
    if (this.timeout) {
      clearTimeout(this.timeout)
    }
  }

  dismiss() {
    // Animate out: fade up
    this.element.classList.remove("opacity-100", "translate-y-0")
    this.element.classList.add("opacity-0", "-translate-y-4")
    setTimeout(() => {
      this.element.remove()
    }, 300)
  }
}
